import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-page-non-autorise',
    templateUrl: './page-non-autorise.component.html',
    styleUrls: ['./page-non-autorise.component.scss'],
    imports: [RouterLink]
})
export class PageNonAutoriseComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
